/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GynaecChecklist from './gynaec-checklist';
import GynaecChecklistDetail from './gynaec-checklist-detail';
import GynaecChecklistUpdate from './gynaec-checklist-update';
import GynaecChecklistDeleteDialog from './gynaec-checklist-delete-dialog';

const GynaecChecklistRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GynaecChecklist />} />
    <Route path="new" element={<GynaecChecklistUpdate />} />
    <Route path=":id">
      <Route index element={<GynaecChecklistDetail />} />
      <Route path="edit" element={<GynaecChecklistUpdate />} />
      <Route path="delete" element={<GynaecChecklistDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GynaecChecklistRoutes;
